import { useEffect, useState } from "react";
import { Badge, Card, Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { getConversationsList, initiateConversation } from "store/services/clientMessagingService";
import ChatSidebar from "./Component/ChatSidebar";
import { FULL_NAME } from "helpers/common";
import MessagingInterface from "components/shared/ChatComponent/MessagingInterface";
import NoChatSelected from "./Component/NoChatSelected";
import { useWebSocket } from "Providers/WebSocketContext";
import { Link, useNavigate } from "react-router-dom";
import NewConversationPopup from "./Component/Modals/NewConversationPopup";
import { dashboard } from "Routes/paths";

// icns

const ClientMessaging = ({
  dispatch,
  userInfo,
  conversationList
}) => {

  const [selectedConversation, setSelectedConversation] = useState(null);
  const [showNewConvPopup, setShowNewConvPopup] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const {isConnected, isChatEnabled} = useWebSocket();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getConversationsList());
  }, []);

  useEffect(() => {
    if (!isChatEnabled) {
      navigate(dashboard);
    }
  }, [isChatEnabled]);

  const handleSelectConversation = (conv) => {
    setSelectedConversation(conv);
  }

  const clientFullName = (conv) => {
    return FULL_NAME(conv.client_first_name, conv.client_last_name)
  }

  const closeNewConversationPopup = () => {
    setShowNewConvPopup(false);
  }

  const handleStartNewConv = async (clientId) => {
    try {
      setLoading(true);
      await dispatch(initiateConversation(clientId));
      closeNewConversationPopup();
    } catch(err) {
      console.error("Failed to initialze conversation", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <NewConversationPopup
        showPopup={showNewConvPopup}
        handleClose={closeNewConversationPopup}
        handleSubmit={handleStartNewConv}
        isLoading={isLoading}
      />
      <section className="d-flex">
        <Container fluid>
          <Row className="my-4">
            <Col lg={12}>
            {conversationList?.length > 0 ? (
              <>
              <NewConversationLink
                handleClick={setShowNewConvPopup}
              />
              
              <Row>
                <Col lg={3} className="p-0 border border-end-0">
                  <ChatSidebar
                    conversations={conversationList}
                    selectedConversationId={selectedConversation?.conversation_id}
                    onSelect={handleSelectConversation}
                  />
                </Col>
                <Col lg={8} className="p-0 border">
                  <div style={{ height: "500px", position: "relative" }}>
                    {selectedConversation ? (
                      <>
                        <div className="p-3 d-flex justify-content-between align-items-center border-bottom bg-light shadow-sm">
                          <div>
                            <h6 className="fw-sbold theme-clr">{clientFullName(selectedConversation)}</h6>
                          </div>
                          {/* <Badge bg={isConnected ? "success" : "secondary"}>
                            {isConnected ? "Active" : "Inactive"}
                          </Badge> */}
                        </div>
                        <MessagingInterface
                          userId={userInfo?.id}
                          clientId={selectedConversation?.client_id}
                          conversationId={selectedConversation?.conversation_id}
                          clientName={clientFullName(selectedConversation)}
                        />
                      </>
                    ) : (
                      <NoChatSelected />
                    )}
                  </div>
                </Col>
              </Row>
              </>
            ):(
              <Row>
                <Col lg="12">
                <div className="new-converstaion d-flex flex-column align-items-center justify-content-center py-5 text-center">
                  <h5 className="mb-3">No conversations yet</h5>
                  <p className="text-muted mb-4">You haven't started any chats. Start a conversation with a client to begin messaging.</p>
                  <NewConversationLink
                    handleClick={setShowNewConvPopup}
                  />
                </div>
                </Col>
              </Row>
            )}
            </Col>
          </Row>
        </Container>

      </section>
    </>
  );
};

const NewConversationLink = ({ handleClick }) => {
  return (
    <Link
      onClick={() => handleClick(true)}
      className="my-2"
    >
      <i className="fa fa-plus" aria-hidden="true"></i> Start New Conversation
    </Link>
  )
}

const mapStateToPros = (state) => {
  let dashboardData = state.Misc.dashboardData;
  return {
    authentication: state.Auth.isAuthenticated,
    user: state.Auth.user,
    profile: state.Profile?.user,
    is_free_account: state.Profile?.is_free_account,
    completedForms: dashboardData.completed_forms,
    favoriteClients: dashboardData.favorite_clients,
    feelingLog: dashboardData.latest_log,
    recentEvents: dashboardData.recentEvents,
    taggedClients: dashboardData.tagged_clients,
    upcomingAppointments: dashboardData.upcoming_appointments,
    announcements: dashboardData.announcements,
    tags: state.Tags.tags,
    accountSettings: state.AccountSetting.accountSettingList,
    stepsProgress: state.Misc.stepsProgress,

    userInfo: state.Profile.user,
    conversationList: state.ClientMessaging.conversationList,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(ClientMessaging);